import { Button } from "@/shadcn/components/ui/button";
import { Calendar } from "@/shadcn/components/ui/calendar"; // Ensure this is the correct Calendar component
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcn/components/ui/popover";
import { formatDueDate } from "@/utils/utils";
import { CalendarIcon } from "lucide-react";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

type DueDatePickerProps = {
  dueDate: Date | null | undefined;
  onDateChange: (date: Date | undefined | null) => void;
  setDueDate?: Dispatch<SetStateAction<Date | null | undefined>>;
  modal: boolean;
  createDueDateOpen?: React.MutableRefObject<boolean>;
  disabled?: boolean;
};

const DueDatePicker: React.FC<DueDatePickerProps> = ({
  dueDate,
  onDateChange,
  setDueDate,
  modal,
  createDueDateOpen,
  disabled,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleFieldDueDate = (date: Date | undefined | null) => {
    if (setDueDate) {
      setDueDate(date);
    }
    onDateChange(date);
    setIsCalendarOpen(false);
  };

  useEffect(() => {
    if (createDueDateOpen) {
      createDueDateOpen.current = isCalendarOpen;
    }
  }, [isCalendarOpen, createDueDateOpen]);

  const handleOpenChange = (open: boolean) => {
    if (disabled) {
      return;
    }
    setIsCalendarOpen(open);
  };

  return (
    <Popover
      modal={modal}
      open={isCalendarOpen}
      onOpenChange={handleOpenChange}
    >
      <PopoverTrigger asChild>
        <Button
          id="edit-due-date"
          variant="outline"
          className={`w-full justify-start text-left font-normal ${
            !dueDate && "text-muted-foreground"
          }`}
          onMouseDown={(e) => {
            e.stopPropagation();
            // if (!isCalendarOpen) {
            //   setIsCalendarOpen(true);
            // }
          }}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dueDate ? formatDueDate(dueDate) : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto p-0"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {isCalendarOpen && (
          <Calendar
            mode="single"
            selected={dueDate ? new Date(dueDate) : undefined}
            onSelect={(date) => {
              handleFieldDueDate(date);
            }}
            autoFocus
            weekStartsOn={1}
          />
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DueDatePicker;
